export default __webpack_public_path__ + "static/media/plane.d2066141.png";